import Swiper from 'swiper';

window.customElements.define('x-context-nav', class extends HTMLElement {
  constructor() {
    super();
    let activeElement = this.querySelector('.btn-primary');
    const allElements = this.querySelectorAll('.swiper-slide');
    let initialSlide = 0;
    if (activeElement && allElements) {
      activeElement = activeElement.parentElement;
      allElements.forEach((e, i) => {
        if (e === activeElement) {
          initialSlide = i;
        }
      });
    }

    this.swiper = new Swiper(this, {
      slidesPerView: 'auto',
      spaceBetween: this.getAttribute('space-between'),
      slidesOffsetAfter: 80,
      initialSlide,
      on: {
        slideChange: () => {
          if (this.swiper.activeIndex >= 1) {
            this.classList.add('show-fade-left');
          } else {
            this.classList.remove('show-fade-left');
          }
        },
        sliderMove: () => {
          this.classList.add('show-fade-left');
        },
        touchEnd: () => {
          if (this.swiper.activeIndex >= 1) {
            this.classList.add('show-fade-left');
          } else {
            this.classList.remove('show-fade-left');
          }
        },
      },
    });
  }
});
